import LayoutAuth from '@common/LayoutAuth'
import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import s from './index.module.css'
import common from '../common.module.css'
import { SetTitlePage } from '@common/SetTitlePage'
import { Button, Form, Input, Modal, Radio, Select } from 'antd'
import classNames from 'classnames'
import {Config, Connect} from "@vkontakte/superappkit";
import {SETTINGS_TYPES} from "@/constant";
import { Redirect } from 'react-router-dom';
import { settingApi, smsIntegrationApi, usersAPI } from "@/api";
import { MyPdfViewer } from "@common/Probes/Probes";
import userAgreementPDF from "../file/userAgreement.pdf"
import privacyPolicyPDF from "../file/privacyPolicy.pdf"
import {IcoRemove} from "@pages/Admin/constsIcon";
import { VKIcon } from '@/utils/icons'
import CheckboxViolet from '@UI/New/ChecboxViolet/CheckboxViolet'
import { Link } from 'react-router-dom'
import { jsonConvert } from '@/helpers/jsonConvert'
import { sortingArray } from '@/helpers/sortingArray'
import { useAddAlert } from '@/hooks/useAddAlert'
import Preloader from '@UI/Preloader'

const DOCUMENTS = {
  userAgreement: userAgreementPDF,
  privacyPolicy: privacyPolicyPDF,
};

const Register = () => {
  const addAlert = useAddAlert();
  const [settings, setSettings] = useState(null);
  const ordersForConfirmation = !!settings?.ordersForConfirmation?.length ? jsonConvert(settings?.ordersForConfirmation) : [];
  const [isAgreementAccepted, setIsAgreementAccepted] = useState(true);
  const [openedDocument, setOpenedDocument] = useState(null); // 'userAgreement' | 'privacyPolicy' | null
  const handleOpenDocument = (type) => setOpenedDocument(type);
  const handleCloseDocument = () => setOpenedDocument(null);
  const [token, setToken] = useState('');
  const [codeDeliveryMethod, setCodeDeliveryMethod] = useState('') // 'sms' или 'telegram'

  useEffect(() => {
    settingApi.getAll()
      .then(response => {
          const items = response.data.filter(item => item.type === SETTINGS_TYPES.GENERAL);
          const generalSettings = {};
          items.forEach(item => Object.assign(generalSettings, { [item.key]: item.value }));
          setSettings(generalSettings);
      });
  }, []);
  
  const hist = useHistory()
  const [loading, setLoading] = useState(false)
  const [isUseEmail, setIsUseEmail] = useState(true)
  
  const confirmationByPhoneNumber = settings?.confirmationByPhoneNumber == 1;
  const confirmationByTelegram = settings?.confirmationByTelegram == 1;
  const isSmsIntegration = (settings?.sms_integration_enabled == 1 && (confirmationByPhoneNumber || confirmationByTelegram)) && (settings?.isEmailAndPhoneRegistration === '1' || !isUseEmail);
  const getToken = isSmsIntegration && !token;
  
  useEffect(() => {
    if(settings?.isDisableEmailRegistration === '1'){
      setIsUseEmail(false)
    } 
  }, [settings?.isDisableEmailRegistration]);

  const register = async (data) => {
    
    let newData = {};

    if(data?.prefix){
      newData = {
        ...data,
        phone: `${data?.prefix} ${data?.phone?.replace(/[^\d\+\(\)\-' ']/g, '')}`
      }
    }
    else{
      newData = {...data}
    }
    
    delete newData?.prefix;
    

    setLoading(true)
    let type = isSmsIntegration ? 'phone' : isUseEmail ? 'email' : 'phone';
    const api = getToken ? smsIntegrationApi.getToken : usersAPI.register;
    const requestData = getToken ? {
          phone: newData.phone,
          type: [codeDeliveryMethod]
    } : 
    { 
      data: {
        ...newData,
        type: type,
        ...( !!token && { token}) 
      } 
    };

    const result = await api(requestData)
    console.log(result)
    setLoading(false)

    if (result?.data?.status === 'success') {
      if(getToken){
            setToken(result?.data?.token)
            addAlert({title: 'Код отправлен', text: 'Заполните поле с кодом подтверждения'})
      }
      else{
          console.log('тут')
          Modal.success({
            autoFocusButton: null,
            centered: true,
            afterClose: () => hist.push('/auth'),
            title: 'Регистрация успешна!',
            content: 'Введите свой логин и пароль для авторизации в личном кабинете',
          })
      }
    } else {
      console.log(result)
      Modal.error({
        autoFocusButton: null,
        centered: true,
        title: 'Регистрация',
        content: result?.response?.data?.error,
      })
    }
  }

  const VkAuth = () => {
    Config.init({
      appId: process.env.REACT_APP_VK_APP_ID,
    });

    let url = `${window.location.protocol}//${window.location.hostname}`

    if (window.location.port) {
      url = url + ':' + window.location.port
    }

    Connect.redirectAuth({
      url: `${url}/signup-vk`,
      state: ''
    })
  }

  const onFinish = (data) => register(data)

  const { Option } = Select;
  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select disabled={loading} style={{ width: 80, background:'#fff'}} >
        <Option value="+7">+7</Option>
        <Option value="+375">+375</Option>
        <Option value="+997">+997</Option>
        <Option value="+374">+374</Option>
        <Option value="+996">+996</Option>
        <Option value="+998">+998</Option>
        <Option value="+44">+44</Option>
        <Option value="+33">+33</Option>
        <Option value="+34">+34</Option>
        <Option value="+91">+91</Option>
      </Select>
    </Form.Item>
  );

  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  
  const onFieldsChange = () => {
    try {
      const values = form.getFieldsValue();
      const errors = form.getFieldsError();
      
      // Проверяем что:
      // 1. Все обязательные поля заполнены
      // 2. Нет ошибок валидации
      // 3. Принято пользовательское соглашение
      const isValid = 
        values.name &&
        ((values.email && isUseEmail) || (values.phone && !isUseEmail)) &&
        values.password &&
        values.passwordRepeat &&
        isAgreementAccepted &&
        errors.every((field) => !field.errors.length);
        
      setIsFormValid(!!isValid);
    } catch (e) {
      setIsFormValid(false);
    }
  };

  useEffect(()=>{
    onFieldsChange()
  }, [isUseEmail])

  const [confirmationCheckboxes, setConfirmationCheckboxes] = useState([]);
  useEffect(()=>{
    if(settings === null) return;
    const newData = sortingArray([
      ...(confirmationByPhoneNumber ? [{key:'sms', label:'Смс', order: ordersForConfirmation?.findIndex(el=>el=='confirmationByPhoneNumber')}] : []),
      ...(confirmationByTelegram ? [{key: 'telegram', label: 'Telegram', order: ordersForConfirmation?.findIndex(el=>el=='confirmationByTelegram')}] : []),
    ], 'order');

    if(!newData?.length) return;

    setCodeDeliveryMethod(newData?.[0]?.key)
    setConfirmationCheckboxes(newData)
  }, [settings])

  if(settings?.isDisableRegistration === '1'){
    return <Redirect to="/auth" />
  }

  return <LayoutAuth>
    <SetTitlePage title='Регистрация' />
    {
      settings === null ? (
        <Preloader />
      ) : (
        <div className={common.card}>

          <div className={s.wrapper}>
            <h2 className={common.title}>Регистрация нового пользователя</h2>
            {settings?.isEmailAndPhoneRegistration !== '1' && (
                <>
                  {isUseEmail && (
                    <button
                      type="button"
                      className={s.button}
                      onClick={() => setIsUseEmail(false)}
                    >
                      по номеру телефона
                    </button>
                  )}
                  {!isUseEmail && settings?.isDisableEmailRegistration === '0' && (
                    <button
                      type="button" 
                      className={s.button}
                      onClick={() => setIsUseEmail(true)}
                    >
                      использовать e-mail
                    </button>
                  )}
                </>
              )}
          </div>

          <Form 
            className={common.form} 
            initialValues={{ prefix: '+7' }} 
            {...{onFinish, form, onFieldsChange, layout: 'vertical'}}
          >

          <Form.Item name='name' rules={[{required: true, message: 'Пожалуйста, введите ФИО'}]}>
              <Input className={common.input} placeholder='Фамилия Имя Отчество' disabled={loading}/>
            </Form.Item>

            {(settings?.isEmailAndPhoneRegistration === '1' || isUseEmail) && <>
              <Form.Item name='email' rules={[
                {required: true, message: 'Пожалуйста, введите e-mail'},
                {type: 'email', message: 'Введите верный e-mail'}]}
              >
                <Input className={common.input} placeholder='Электронная почта' disabled={loading}/>
              </Form.Item>
            </>
            }

            {(settings?.isEmailAndPhoneRegistration === '1' || !isUseEmail) && <>
              {
                getToken && (
                  <span className={classNames(common.textRed, common.text)}>
                    {`Необходимо подтверждение номера телефона, временный код будет отправлен 
                    ${((confirmationCheckboxes?.length == 1) && (confirmationByPhoneNumber)) ? 'по смс' : ''}
                    ${((confirmationCheckboxes?.length == 1) && (confirmationByTelegram)) ? 'в телеграм' : ''}
                    после заполнения формы`}
                  </span>
                )
              }
            
              <Form.Item
                className={s.stuleSelektKod}
                style={{marginBottom: isSmsIntegration ? '10px' : undefined}}
                name="phone"
                rules={[{ required: true, message: 'Пожалуйста, введите номер телефона' },  {type: 'string', message: 'Введите верный номер телефона'},
                ({getFieldValue}) => ({
                  validator(_, value) {
                    
                    if (value.search(/[^\d\+\(\)\-' ']/g) != -1 ) {
                      return Promise.reject(new Error('Можно вводить только цифры, пробел, скобки и дефис'));
                    }
                    return Promise.resolve();
                  
                  },
                })
              ]}
              >
                <Input className={common.input} disabled={loading} addonBefore={prefixSelector} style={{ width: '100%' }} />
              </Form.Item>
              {
                getToken && confirmationCheckboxes?.length > 1 && <span style={{marginBottom: '10px'}} className={classNames(common.text, common.textRed)}>
                    Выберите, куда отправить вам временный код для подтверждения
                </span>
              }
              {
                getToken && confirmationCheckboxes?.length > 1 && (
                  <Form.Item className={classNames(common.formItem, common.formItemRadio)}>
                    <Radio.Group 
                      value={codeDeliveryMethod}
                      onChange={(e) => setCodeDeliveryMethod(e.target.value)}
                      disabled={loading}
                    >
                      {
                        confirmationCheckboxes.map((el)=>{
                          return(
                            <Radio value={el.key}>{el.label}</Radio>
                          )
                        })
                    }
                    </Radio.Group>
                  </Form.Item>
                )
              }
              {
                !!token && (
                  <Form.Item 
                    name='code' 
                    rules={[
                      { required: true, message: 'Пожалуйста, введите код подтверждения' }
                    ]}
                  >
                    <Input 
                      className={classNames(common.input, s.input)} 
                      placeholder='Код подтверждения' 
                      disabled={loading} 
                    />
                  </Form.Item>
                )
              }
            </>}

            <Form.Item name='password' rules={[{required: true, message: 'Пожалуйста, введите пароль'}]}>
              <Input className={common.input} placeholder='Пароль' type="password" disabled={loading}/>
            </Form.Item>
            <Form.Item name='passwordRepeat' dependencies={['password']} rules={[
              {required: true, message: 'Пожалуйста, введите пароль повторно'},


              ({getFieldValue}) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Пароли не совпадают'));
                },
              }),


            ]}>
              <Input className={common.input} placeholder='Повторите пароль' type="password" disabled={loading}/>
            </Form.Item>

            <div className={common.agreement}>
                <div className={common.checkboxWrapper}>
                  <CheckboxViolet
                    className={common.checkbox}
                    value={isAgreementAccepted}
                    setValue={setIsAgreementAccepted}
                  />
                </div>
                <div className={common.textAgreement}>
                  Принимаю
                  <span onClick={() => handleOpenDocument('userAgreement')}>пользовательское соглашение</span> и
                  <span onClick={() => handleOpenDocument('privacyPolicy')}>политику конфиденциальности</span>
                </div>
            </div>

            <Form.Item>
              <div className={common.buttons}>
                <Button 
                  disabled={!isAgreementAccepted} 
                  htmlType="submit" 
                  className={classNames(common.btnSubmit, { [common.active]: isFormValid && isAgreementAccepted })} 
                  {...{loading}}>
                  Зарегистрироваться
                </Button>
                {
                  settings?.isDisableloginViaVK === '0' && (
                    <Button disabled={!isAgreementAccepted} htmlType="button" className={common.buttonLoginVk} onClick={VkAuth}>
                      Зарегистрироваться через <VKIcon />
                    </Button>
                  )
                }
              
              </div>
            </Form.Item>

            <div className={common.bottomLinks}>
              Уже есть аккаунт? <Link className={common.link} to='/auth'>Войти</Link>
            </div>

          </Form>
          {openedDocument && (
            <div className={common.modal} onClick={(e) => e.target === e.currentTarget && handleCloseDocument()}>
              <div className={common.modalContent}>
                <IcoRemove onClick={handleCloseDocument} className={common.icoRemove} />
                <MyPdfViewer presentation={true} file={DOCUMENTS[openedDocument]} />
              </div>
            </div>
          )}
        </div>
      )
    }
    
  </LayoutAuth>
}

export default Register